var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .close-class-a {\n                fill: none !important;\n            }\n\n            .close-class-b {\n                fill: #f5f8fa;\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "close-class-a",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "close-class-b",
    d: "M86.549,506,96,496.549,94.451,495,85,504.451,75.549,495,74,496.549,83.451,506,74,515.451,75.549,517,85,507.549,94.451,517,96,515.451Z",
    transform: "translate(-69 -490)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_close.03bfb21f08b61c95d22a8cc25dcdb1de.svg";